export default __webpack_public_path__ + "static/media/ps_07.6258547c.png";